import { registerQuery } from 'data-fetching-client';
import { fetchPermissionsForFlows } from 'automation-ui-permissions/flp/api/flpAccessApi';
const BATCH_TIMEOUT_MS = 100;
const makeFlpPermissionsBatchFetcher = () => {
  const flowIds = new Set();
  let promise = null;
  return flowId => {
    flowIds.add(flowId);
    if (!promise) {
      promise = new Promise(resolve => {
        setTimeout(() => {
          resolve(fetchPermissionsForFlows(Array.from(flowIds)));
          flowIds.clear();
          promise = null;
        }, BATCH_TIMEOUT_MS);
      });
    }
    return promise;
  };
};
const flpPermissionsBatchFetcher = makeFlpPermissionsBatchFetcher();
export const FETCH_FLP_ACCESS = registerQuery({
  fieldName: 'fetchFlpAccess',
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return flpPermissionsBatchFetcher(flowId).then(res => {
      const matchingPermissions = res.results.find(permissions => permissions.flowId === flowId);
      if (matchingPermissions) {
        return matchingPermissions;
      }
      throw new Error(`Couldn't find permissions for flowId ${flowId}`);
    });
  }
});
export const FETCH_FLP_ACCESS_BULK = registerQuery({
  fieldName: 'fetchFlpAccessBulk',
  args: ['flowIds'],
  fetcher({
    flowIds
  }) {
    return fetchPermissionsForFlows(flowIds);
  }
});